// Imports
import $ from 'jquery';
jQuery.noConflict();

import { 
    isInputNumber 
} from "./custom/form/js-validation";

import { 
    youtubeFunctions,
    youtubeStateChangeFunctions
} from "./custom/youtube";

window.isInputNumber = isInputNumber;

jQuery(function() { 
    youtubeFunctions();   

    if ($("#product-attribute-specs-table").length) {
        $("#product-attribute-specs-table tr").each(function () {
            if ($(this).children("td.data").html() == "N/A" || $(this).children("td.data").html() == "No") {
                $(this).remove();
            }
        });
    }
    
    if ($("#narrow-by-list").length) {
        $("#narrow-by-list dd li").each(function () {
            if ($(this).children("a").html() == "N/A" || $(this).children("a").html() == "No") {
                $(this).remove();
            }
        });
    }

    jQuery('#product-attribute-specs-table tr:odd').addClass('odd');
    jQuery('#product-attribute-specs-table tr:even').addClass('even');
});

jQuery(window).on('load resize orientationchange', function() {
    youtubeStateChangeFunctions();
});
